import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import es from './locales/es.json';
import ru from './locales/ru.json';
import lt from './locales/lt.json';

const resources = {
  en: { translation: en },
  es: { translation: es },
  ru: { translation: ru },
  lt: { translation: lt },
};

const supportedLanguages = ['es', 'en', 'ru', 'lt'];

// Get language from localStorage or browser
const getInitialLanguage = (): string => {
  // 1. Check localStorage
  const savedLanguage = localStorage.getItem('language');
  if (savedLanguage && supportedLanguages.includes(savedLanguage)) {
    return savedLanguage;
  }

  // 2. Check browser language
  const browserLanguage = navigator.language.split('-')[0]; // e.g., 'en-US' -> 'en'
  if (supportedLanguages.includes(browserLanguage)) {
    return browserLanguage;
  }

  // 3. Default to Spanish
  return 'es';
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

// Save language to localStorage when it changes
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
});

export default i18n;
